import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { AddToWishlistRequest } from './addtowishlistrequest';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { BaseContext } from '../../../../utils/basecontext';
import { POST } from '../../api';
// import {encode} from 'html-entities';

export class AddToWishlistAPI extends SixdeeCRBTAPI<AddToWishlistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/add-to-wishlist
        return "add-to-wishlist";
    }

    getRequestData()
    {   
        return "identifier="+ this.getRequest().getAddToWishlistRequest().getIdentifier()+"&"+
               "msisdn="+ this.getRequest().getAddToWishlistRequest().getMsisdn()+"&"+
               "contentId="+ this.getRequest().getAddToWishlistRequest().getContentId()+"&"+
               "contentName="+ (encodeURIComponent(this.getRequest().getAddToWishlistRequest().getContentName()))+"&"+
               "path="+ (encodeURIComponent(this.getRequest().getAddToWishlistRequest().getPath()))+"&"+
               "previewImage="+ (encodeURIComponent(this.getRequest().getAddToWishlistRequest().getPreviewImage()))+"&"+
               "album="+ this.getRequest().getAddToWishlistRequest().getAlbum()+"&"+
               "artist="+ (encodeURIComponent(this.getRequest().getAddToWishlistRequest().getArtist()))+"&"+
               "price="+ this.getRequest().getAddToWishlistRequest().getPrice()+"&"+
               "language="+ this.getRequest().getAddToWishlistRequest().getLanguage()+"&"+
               "wishlistType="+ this.getRequest().getAddToWishlistRequest().getWishlistType();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/addtowishlist/addtowishlistapi.tsx